import { GameServices } from "game/GameServices";
import { Container, DisplayObject, TextMetrics, TextStyle } from "pixi.js";

export function CreateComplexText(services: GameServices, message: string, textSpecs: any[], spriteSpecs: any[], chunkData: string[], parent?: Container<DisplayObject>, newLineSpacing: number = NaN, debug: boolean = false): Container {

    // Construction the raw message data
    let chunkIndex = 0;
    while (message.includes(`{chunk`)) {

        let currentChunkIndex = chunkIndex;
        const chunkSuffix = message.split(`{chunk`)[1].split(`}`)[0];
        if (chunkSuffix.includes(`:`)){
            currentChunkIndex = Number(chunkSuffix.split(`:`)[1]);
        } else {
            chunkIndex++;
        }

        message = message.replace(`{chunk${chunkSuffix}}`, `{${chunkData[currentChunkIndex]}}`);
    }
    const rawMessageList: string[] = message.replace(/\n/g, Number.isNaN(newLineSpacing) ? `{newLine}` : `{newLine:${newLineSpacing}}`).split(`{`);

    // Create the main container
    const mainContainer = new Container();
    if (parent) {
        parent.addChild(mainContainer);
    }

    // Create first layer container (used for new lines to keep everything centred)
    let containerLayer = new Container();
    containerLayer.name = `I`;
    mainContainer.addChild(containerLayer);

    // Default text spec to the first one provided
    let currentTextSpec: any = textSpecs[0];
    let xOffset = 0;

    // Cycle through raw message data
    for (let rawIndex = 0; rawIndex < rawMessageList.length; rawIndex++) {

        const messageData = rawMessageList[rawIndex];
        if (!messageData.includes(`}`)) {   // No chunk data found (just create text if text is present)

            if (messageData == ``) { continue; }

            const newText = services.factory.createText(messageData, currentTextSpec, containerLayer);
            newText.x += xOffset;

            // Increment x offset to prepare for next text item
            xOffset += TextMetrics.measureText(messageData, newText.style as TextStyle).width;
            if (debug) console.log(`X OFFSET INCREASE (TEXT): '${messageData}' ${TextMetrics.measureText(messageData, newText.style as TextStyle).width}`);
        } else {    // Chunk data found (apply chunk data then create text if text is present)

            const messageSegments: string[] = messageData.split(`}`);   // Split message data into list of chunk data and message text
            const args: string[] = messageSegments[0].split(`|`);   // Split chunk data into a list of arguments
            const nextMessage: string = messageSegments[1]; // Get the message text

            for (let argIndex = 0; argIndex < args.length; argIndex++) {    // Cycle through arguments

                const subArgs: string[] = args[argIndex].split(`:`);    // Fetch subarguments number (e.g. sprite:0 -> ["sprite", "0"])
                switch (subArgs[0]) {   // Perform specific argument behaviour
                    case `text`:
                        // Update current text spec
                        currentTextSpec = textSpecs[parseInt(subArgs[1])];
                        break;
                    case `newLine`:
                        // Position old layer container and move onto a new layer container (effectively a new line by updating the y of the new container)
                        containerLayer.x = -containerLayer.width / 2;
                        if (debug) console.log(`Y OFFSET INCREASE (TEXT): ${subArgs.length > 1 ? parseFloat(subArgs[1]) : containerLayer.height}`);
                        const newY = containerLayer.y + (subArgs.length > 1 ? parseFloat(subArgs[1]) : containerLayer.height);
                        const newLayerName = containerLayer.name + `I`;
                        containerLayer = new Container();
                        containerLayer.name = newLayerName;
                        containerLayer.y = newY;
                        mainContainer.addChild(containerLayer);
                        xOffset = 0;
                        break;
                    case `sprite`:
                        // Create a new sprite
                        const newSprite = services.factory.createSprite(spriteSpecs[parseInt(subArgs[1])], containerLayer);
                        newSprite.x = xOffset;
                        xOffset += newSprite.width;
                        if (debug) console.log(`X OFFSET INCREASE (SPRITE): ${newSprite.width}`);
                        break;
                    case `shift`:
                        // Shift x offset for manual adjustments
                        xOffset += parseFloat(subArgs[1]);
                        if (debug) console.log(`X OFFSET INCREASE (SHIFT): ${parseFloat(subArgs[1])}`);
                        break;
                }
            }

            // Create new message if message text is found
            if (nextMessage == ``) { continue; }

            const newText = services.factory.createText(nextMessage, currentTextSpec, containerLayer);
            newText.x = xOffset;

            // Increment x offset to prepare for next text item
            xOffset += TextMetrics.measureText(nextMessage, newText.style as TextStyle).width;
            if (debug) console.log(`X OFFSET INCREASE (TEXT): '${nextMessage}' ${TextMetrics.measureText(nextMessage, newText.style as TextStyle).width}`);
        }
    }

    // Centre position of remaining layer container
    containerLayer.x = -containerLayer.width / 2;

    // Return container containing every complex text element
    return mainContainer;
}
